/*eslint no-undef: 0*/

import scrollTopAfterAjax from '../util/scroll-top-ajax';

const ajaxNewsEvents = () => {
  let
    $postsWrapper = $('#posts-wrapper'),
    pageWrapper = $('#pagination-wrapper'),
    $category = $('#category'),
    $tag = $('#tag'),
    loader = $('#skeleton-parent'),
    isProcessing = false,
    page = 1;


  // Pagination wrap toggle visibility
  const markupDecorators = response => {
    //
    if (response.pagination === null) {
      pageWrapper.addClass('d-none');
    } else {
      pageWrapper
        .removeClass('d-none')
        .html(response.pagination);
    }
  };


  // Get posts
  const getNewsEvents = () => {
    $.ajax(
      {
        url: follow.ajax_url,
        type: 'GET',
        dataType: 'json',
        cache: true,
        data: {
          action: 'get_news_events',
          category: $category.val(),
          tag: $tag.val(),
          paged: page,
          security: follow.nonce,
        },
        beforeSend: function () {
          loader.removeClass('is-invisible d-none');
          $postsWrapper.addClass('d-none').empty();
        },
        success: function (response) {
          //
          $postsWrapper.removeClass('d-none');

          loader.addClass('d-none').promise().done(function () {
            //
            $postsWrapper.html(response.html);

            //
            markupDecorators(response);

            //
            if (isProcessing)
              scrollTopAfterAjax($postsWrapper, isProcessing);

            //
            isProcessing = false;
          });
        },
      }
    );
  };


  // Init getNewsEvents
  getNewsEvents();

  // Pagination click event handler
  pageWrapper.on('click', '.page-link', function (e) {
    e.preventDefault();

    //
    let el = $(this);

    if (isProcessing || el.hasClass('current')) return;
    isProcessing = true;

    //
    page = $(this).data('page');
    //
    getNewsEvents();
  });
};


// Init ajaxNewsEvents
ajaxNewsEvents();



// WEBPACK FOOTER //
// ./scripts/ajax/ajax-news-events.js